import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home flex flex-col items-center" }
const _hoisted_2 = { class: "w-full bg-slate-900/80 backdrop-blur-[3px]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto mt-20 h-1 w-11/12 rounded-full bg-slate-700 shadow-md" }, null, -1)
const _hoisted_4 = { class: "w-full bg-slate-900/80 backdrop-blur-[3px]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto mt-20 h-1 w-11/12 rounded-full bg-slate-700 shadow-md" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")!
  const _component_about_component = _resolveComponent("about-component")!
  const _component_services_component = _resolveComponent("services-component")!
  const _component_values_component = _resolveComponent("values-component")!
  const _component_diversity_component = _resolveComponent("diversity-component")!
  const _component_contact_us_component = _resolveComponent("contact-us-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_header_component, {
      "sub-title": _ctx.slogan,
      "text-block": _ctx.companyBlock,
      button: _ctx.headerButton
    }, null, 8, ["sub-title", "text-block", "button"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_about_component, {
        title: _ctx.aboutTitle,
        slogan: _ctx.slogan,
        "company-block": _ctx.companyBlock,
        "founder-name": _ctx.founderName,
        "founder-role": _ctx.founderRole,
        "founder-quote": _ctx.founderQuote
      }, null, 8, ["title", "slogan", "company-block", "founder-name", "founder-role", "founder-quote"]),
      _hoisted_3,
      _createVNode(_component_services_component, {
        title: _ctx.servicesTitle,
        block: _ctx.servicesBlock,
        services: _ctx.services
      }, null, 8, ["title", "block", "services"])
    ]),
    _createVNode(_component_values_component, {
      title: _ctx.valuesTitle,
      block: _ctx.valuesBlock,
      values: _ctx.values
    }, null, 8, ["title", "block", "values"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_diversity_component, {
        title: _ctx.diversityTitle,
        blocks: _ctx.diversityBlocks
      }, null, 8, ["title", "blocks"]),
      _hoisted_5,
      _createVNode(_component_contact_us_component, {
        title: _ctx.contactUsTitle,
        block: _ctx.contactUsBlock,
        contactTypes: _ctx.contactUsTypes
      }, null, 8, ["title", "block", "contactTypes"])
    ])
  ]))
}